import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useStateService } from '@/shared/services/StateService';
import messages from './messages';
const NoRelationWarningIcon = ({ companyId, intl }) => {
    const stateService = useStateService();
    return (_jsx(OverlayTrigger, Object.assign({ placement: "right", overlay: _jsx(Tooltip, Object.assign({ id: `NoRelationWarning${companyId}` }, { children: intl.formatMessage(messages.NoRelationConfiguredInCompany) })) }, { children: _jsx("a", Object.assign({ href: stateService.getStateUrl('settings.company', { json: { companyId } }), onClick: () => stateService.gotoState('settings.company', { companyId }) }, { children: _jsx("i", { className: "fa fa-exclamation-triangle fa-fw text-danger" }) })) })));
};
export default NoRelationWarningIcon;
